import React from "react";
import { Col, Row } from "react-bootstrap";
import styled from "styled-components";
import { HeaderContainer, ProgramButtonPrimary, ProgramButtonPrimaryOutlined, Title } from "../../styled";

export interface HeaderProps {
    canPublish: boolean;
    onSaveDraft: () => void;
    onPublish: () => void;
}

const HeaderRow = styled(Row)`
    @media (max-width: 768px) {
        gap: 16px !important;
        flex-direction: column !important;
    }
`;

export const Header = ({ canPublish, onSaveDraft, onPublish }: HeaderProps) => {
    return (
        <HeaderContainer>
            <HeaderRow className="d-flex flex-row">
                <Col className="p-0">
                    <Title>Criar novo programa</Title>
                </Col>
                <Col className="p-0 d-flex flex-row justify-content-start justify-content-md-end">
                    <ProgramButtonPrimaryOutlined onClick={onSaveDraft}>Salvar rascunho</ProgramButtonPrimaryOutlined>
                    <ProgramButtonPrimary disabled={!canPublish} onClick={onPublish}>Publicar</ProgramButtonPrimary>
                </Col>
            </HeaderRow>
        </HeaderContainer>
    );
};